module.exports = __webpack_public_path__ + "img/qrcode.614354a0.jpg";